import React, {Component} from "react";
import {withTranslation} from "react-i18next";
import {connect} from "react-redux";

import styled from "@emotion/styled";
import sv from "../styles/styles";
import AuthBase from "../components/AuthBase";
import AuthButton from "../components/AuthButton";
import AuthError from "../components/AuthError";
import AuthFormField from "../components/AuthFormField";
import {AnimatedLoader, Container, StyledMedia} from "../styles/CommonStyler";
import {Header} from "../components/Header";
import Footer from "../components/Footer";

import {alertActions, userActions} from "../_actions";
import {alertActionTypes} from "../_constants";
import {isMobileOnly} from "react-device-detect";

// STYLE ##########################################################

const Actions = styled(`div`)`
    margin-top: 24px;
    ${sv.flexRow}
`;

const Options = styled(`div`)`
  ${sv.label};
  text-transform: none;
  margin-top: 24px;
  ${sv.flexCenter};
`;

// COMPONENT ##########################################################

class PasswordChange extends Component {

    constructor(props) {
        super(props);

        this.state = {
            oldPassword: '',
            newPassword: ''
        };

        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    handleChange(e) {
        const {name, value} = e.target;
        this.setState({[name]: value});
    }

    handleSubmit(e) {
        const {t} = this.props;
        const {oldPassword, newPassword} = this.state;

        e.preventDefault();

        if (!oldPassword || !newPassword || newPassword.length < 6 || oldPassword.length < 6) {
            this.props.dispatchEmptyFieldError({"errorMsg": t("Sorry, password needs to be at least 6 characters")})
        } else {
            this.props.passwordChange(oldPassword, newPassword);
        }
    }

    render() {
        const {users, alert, t} = this.props;
        const {passwordChange} = users;

        return (
            <StyledMedia>
                <Container isMobile={isMobileOnly}>
                    <Header />

                    <AuthBase title={t('Change Password')+"."}>
                        {alert.type === alertActionTypes.ERROR && <AuthError error={alert.message.errorMsg}/>}
                        <AuthFormField
                            password
                            label={t('Confirm current password')}
                            placeholder={t('Enter password')}
                            update={this.handleChange}
                            name="oldPassword"
                            onEnterPressed={this.handleSubmit}
                        />
                        <AuthFormField
                            password
                            label={t('New Password')}
                            placeholder={t('Enter password')}
                            update={this.handleChange}
                            name="newPassword"
                            onEnterPressed={this.handleSubmit}
                        />
                        <Actions>
                            <AuthButton cancel onClick={() => this.props.history.goBack()}>{t('Cancel')}</AuthButton>
                            <AuthButton onClick={this.handleSubmit} id="submit">{t('Change Password')}</AuthButton>
                        </Actions>

                        {passwordChange && passwordChange.loading &&
                        <Options>
                            <AnimatedLoader color={sv.colors.cta}/>
                        </Options>
                        }
                    </AuthBase>

                    <Footer />
                </Container>
            </StyledMedia>
        );
    }

}

function mapStateToProps(state) {
    const {users, alert} = state;
    return {
        users, alert
    };
}

function mapDispatchToProps(dispatch) {
    return {
        passwordChange: (oldPassword, newPassword) => dispatch(userActions.changePassword(oldPassword, newPassword)),
        dispatchEmptyFieldError: (msg) => dispatch(alertActions.error(msg))
    };
}

const connectedPasswordChange = withTranslation()(connect(mapStateToProps, mapDispatchToProps)(PasswordChange));
export {connectedPasswordChange as PasswordChange};